































































































































































import { Component, Vue } from "vue-property-decorator";

import {
  HomeHistoryItemInterface,
  PolyDialogTypeInterface
} from "@/interfaces";

@Component({
  components: {}
})
export default class SettingsPage extends Vue {
  toastMessage: string = "";
  toast: boolean = false;

  loggedInEmail: string = "";
  isLoading: boolean = false;

  historyHasItems: boolean = false;
  userDataExists: boolean = false;
  timetableExists: boolean = false;

  namedTimetables: Array<HomeHistoryItemInterface> = [];

  PAGE_DIALOG_EVENT: string = "SETTINGS_PAGE_DIALOG";
  DIALOG_OPEN_EVENT = "OPEN_DIALOG";

  mounted() {
    // this.setNamedTimetablesArrayFromService();
    this.initDataFromService();

    this.setUpPageDialogListener();
  }

  initDataFromService(): void {
    this.namedTimetables = this.$dataService.getNamedTimetablesArray();

    const serviceTimetables = this.$dataService.getCurrentTimetable();
    const historyItems = this.$dataService.getHistoryItems();

    this.historyHasItems = historyItems.length > 0;
    this.userDataExists = this.historyHasItems || serviceTimetables.length > 0;
    this.timetableExists = serviceTimetables.length > 0;

    this.loggedInEmail = this.$dataService.getLoggedInEmail();
  }

  beforeDestroy() {
    this.$root.$off(this.PAGE_DIALOG_EVENT);
    // this.$root.$off(this.DIALOG_OPEN_EVENT);
  }

  setNamedTimetablesArrayFromService(): void {
    this.namedTimetables = this.$dataService.getNamedTimetablesArray();
  }

  openSaveCurrentTimetableDialog(): void {
    const data: PolyDialogTypeInterface = {
      addTimetableNameSelected: true
    };

    this.openDialog(data);
  }

  openChangeCurrentTimetableNameDialog(
    timetable: HomeHistoryItemInterface
  ): void {
    const data: PolyDialogTypeInterface = {
      changeTimetableNameSelected: true,
      timetableNameToChange: timetable.timetableName
    };

    this.openDialog(data);
  }

  openDeleteTimetableConfirmationDialog(
    timetable: HomeHistoryItemInterface
  ): void {
    const data: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      isDeleteTimetableSelected: true,
      deleteTimetableId: timetable.namedTimetableId
    };

    this.openDialog(data);
  }

  openSignUpDialog(): void {
    const data: PolyDialogTypeInterface = {
      signupSelected: true
    };

    this.openDialog(data);
  }

  openLoginDialog(): void {
    const data: PolyDialogTypeInterface = {
      loginSelected: true
    };

    this.openDialog(data);
  }

  openClearHistoryConfirmationDialog(): void {
    const data: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      clearHistory: true
    };

    this.openDialog(data);
  }

  openClearAllDataConfirmationDialog(): void {
    const data: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      clearAllData: true
    };

    this.openDialog(data);
  }

  openDeleteMyAccountDialog(): void {
    const data: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      deleteMyAccount: true
    };

    this.openDialog(data);
  }

  openLogoutConfirmationDialog(): void {
    // Logout means we still leave the data but online syncing ability is disabled
    const data: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      logoutSelected: true
    };

    this.openDialog(data);
  }

  returnTimetableIDIfExists(timetableName: string): string {
    const foundTimetable: HomeHistoryItemInterface = this.namedTimetables.find(
      (timetable: HomeHistoryItemInterface) =>
        timetable.timetableName!.toLowerCase().trim() ===
        timetableName.toLowerCase().trim()
    ) as HomeHistoryItemInterface;

    return foundTimetable ? (foundTimetable.namedTimetableId as string) : "";
  }

  addNewTimetable(timetableName: string): void {
    const foundTimetableId: string = this.returnTimetableIDIfExists(
      timetableName
    );

    if (foundTimetableId) {
      this.showToast(`Timetable with name ${timetableName} already exists`);
      return;
    }

    try {
      this.$dataService.addANewTimetable(timetableName);
      // this.setNamedTimetablesArrayFromService();
      this.initDataFromService();
    } catch (e) {
      this.showToast(e.message);
    }
  }

  updateExistingTimetableName(
    oldTimetableName: string,
    newTimetableName: string
  ): void {
    const foundTimetableId: string = this.returnTimetableIDIfExists(
      newTimetableName
    );

    if (foundTimetableId) {
      this.showToast(`Timetable with name ${newTimetableName} already exists`);
      return;
    }

    const foundTimetable: HomeHistoryItemInterface = this.namedTimetables.find(
      timetable => timetable.timetableName === oldTimetableName
    ) as HomeHistoryItemInterface;
    this.$dataService.changeExistingTimetableName(
      foundTimetable,
      newTimetableName
    );
    // this.setNamedTimetablesArrayFromService();
    this.initDataFromService();
  }

  async sync(): Promise<void> {
    try {
      this.showToast("Please wait as we sync your data");

      await this.$dataService.getMyState();

      this.initDataFromService();

      this.showToast("Your data was synced successfully");
    } catch (e) {
      this.showToast(e.message);
    }
  }

  async uploadData(): Promise<void> {
    try {
      this.showToast("Please wait as we upload your data");

      await this.$dataService.uploadMyState();

      this.showToast("Your data was uploaded successfully");
    } catch (e) {
      this.showToast(e.message);
    }
  }

  handleTimetableDelete(timetableId: string): void {
    const foundTimetable: HomeHistoryItemInterface = this.namedTimetables.find(
      timetable => timetable.namedTimetableId === timetableId
    ) as HomeHistoryItemInterface;

    this.$dataService.deleteANamedTimetable(foundTimetable);
    // this.setNamedTimetablesArrayFromService();
    this.initDataFromService();
  }

  handleSelectTimetable(timetableNameSelected: string): void {
    this.$dataService.shiftTimetablePriorityUsingName(timetableNameSelected);
    // this.setNamedTimetablesArrayFromService();
    this.initDataFromService();
  }

  async handleSignup(update: PolyDialogTypeInterface): Promise<void> {
    try {
      // Store state in dataService
      this.showToast("Please wait as we sign you up");

      await this.$dataService.loginSignupUser(
        update.email as string,
        update.password as string,
        false
      );

      this.loggedInEmail = update.email as string;
      this.showToast("Successful");
    } catch (e) {
      this.showToast(e.message);
    }
  }

  async handleLogin(update: PolyDialogTypeInterface): Promise<void> {
    try {
      // Store state in dataService
      this.showToast("Please wait as we sign you up");

      await this.$dataService.loginSignupUser(
        update.email as string,
        update.password as string,
        true
      );

      this.loggedInEmail = update.email as string;
      this.showToast("Successful");
    } catch (e) {
      this.showToast(e.message);
    }
  }

  handleClearHistory(): void {
    this.$dataService.clearMyHistory();
    this.initDataFromService();
  }

  handleClearAllData(): void {
    this.$dataService.clearAllMyData();
    this.initDataFromService();
  }

  handleLogout(): void {
    this.$dataService.logoutUser();
    this.initDataFromService();
  }

  async handleForgotPassword(email: string): Promise<void> {
    try {
      // Store state in dataService
      this.showToast(`Sending confirmation to your email`);

      await this.$dataService.forgotMyPassword(email);
    } catch (e) {
      this.showToast(e.message);
    }
  }

  async handleDeleteMyAccount(): Promise<void> {
    try {
      // Store state in dataService
      this.showToast(`Please wait as we delete your account`);

      await this.$dataService.apiDeleteMyAccount();

      this.handleLogout();

      this.showToast(`Account deleted`);
    } catch (e) {
      this.showToast(e.message);
    }
  }

  openDialog(data: PolyDialogTypeInterface): void {
    data.pageEvent = this.PAGE_DIALOG_EVENT;

    this.$root.$emit(this.DIALOG_OPEN_EVENT, data);
  }

  setUpPageDialogListener(): void {
    this.$root.$on(
      this.PAGE_DIALOG_EVENT,
      (update: PolyDialogTypeInterface) => {
        if (!update) return;

        if (update.addTimetableNameSelected)
          this.addNewTimetable(update.updateValue);
        else if (update.selectTimetable)
          this.handleSelectTimetable(update.timetableNameToChange as string);
        else if (update.changeTimetableNameSelected)
          this.updateExistingTimetableName(
            update.timetableNameToChange as string,
            update.updateValue
          );
        else if (update.isConfirmSelected && update.isDeleteTimetableSelected)
          this.handleTimetableDelete(update.deleteTimetableId as string);
        else if (update.signupSelected) this.handleSignup(update);
        else if (update.loginSelected) this.handleLogin(update);
        else if (update.isConfirmSelected && update.clearHistory)
          this.handleClearHistory();
        else if (update.isConfirmSelected && update.clearAllData)
          this.handleClearAllData();
        else if (update.isConfirmSelected && update.logoutSelected)
          this.handleLogout();
        else if (update.forgotPasswordSelected)
          this.handleForgotPassword(update.email as string);
        else if (update.isConfirmSelected && update.deleteMyAccount)
          this.handleDeleteMyAccount();
      }
    );
  }

  showToast(message: string): void {
    const simpleMessage = message.toLowerCase();

    if (
      simpleMessage.includes("typeerror") ||
      simpleMessage.includes("network")
    )
      return;
    else if (
      simpleMessage.includes("html") ||
      simpleMessage.includes("undefined")
    )
      message = "Please try again later";

    this.toastMessage = message;
    this.toast = true;
  }
}
